<script setup>
// import { ref } from 'vue';
import { formatDate } from '@/utils/dateUtils';

import ArgonButton from "@/components/ArgonButton.vue";
// import ArgonInput from "@/components/ArgonInput.vue";
import { inventoryService } from "@/services/inventoryService";

import { useRouter } from 'vue-router';

const router = useRouter();


import { useStore } from "vuex";
import { computed } from "vue";
const store = useStore();
const selectedShop = computed(() =>
    store.getters.selectedShop
);

const props = defineProps({
    categories: {
        type: Array,
        default: () => []
    },
    products: {
        type: Array,
        default: () => []
    },  
    isLoading: Boolean,
    sortBy: String,
    sortDesc: Boolean
});

const emit = defineEmits([
    'sort-changed'
]);

function sort(field) {

    let desc = true;

    if (props.sortBy === field) {
        desc = !props.sortDesc;
    }

    emit('sort-changed', {
        field,
        desc
    });
}

function goToStore() {
  console.log('Selected shop:', selectedShop.value.Url);
  window.open(selectedShop.value.Url + '/Admin/Product/Create', '_blank');
}

/*
const previewVisible = ref(false)

const previewUrl = ref("")

const previewStyle = ref({})

function showPreview(url){

    previewVisible.value=true

    previewUrl.value=url

}

function hidePreview(){

    previewVisible.value=false

}

function movePreview(e){

    previewStyle.value={

        left:e.clientX+20+"px",

        top:e.clientY+20+"px"

    }

}*/
async function createInventory(product) {

    try {

        const response =
            await inventoryService
                .createFromProduct(
                    product.Id
                );


        if (response.data.Success) {

            const inventoryItem =
                response.data.Data;


            router.push({
                name:
                    "InventoryDetails",

                params: {
                    id:
                        inventoryItem.Id
                }
            });

        }

    }
    catch (error) {

        console.error(
            error
        );

    }
}
// function openInventory(product) {

//     router.push({
//         name:
//             "InventoryDetails",

//         params: {
//             id:
//                 product.InventoryItemId
//         }
//     });

// }
</script>
<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col-12">
          <div>
              
          </div>
          <div class="d-flex align-items-center">
            <h6 class="mb-0">Products: {{ products?.length ?? 0  }} Kategorii: {{ props.categories.length }}</h6>
            <argon-button color="dark" variant="gradient"  size="sm" class="ms-auto" @click="goToStore"><i class="fas fa-plus me-2"></i>Add New Product </argon-button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <!-- <div v-if="props.isLoading" class="loading-overlay">
          <div class="spinner"></div>
          <div>Ładowanie produktów...</div>
        </div> -->
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" @click="sort('Id')">
                <span>Id</span>
                <span v-if="sortBy === 'Id'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('Name')" >
                <span>Name</span>
                <span v-if="sortBy === 'Name'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('CategoryName')">
                <span>Category</span>
                <span v-if="sortBy === 'CategoryName'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('Sku')">
                <span>Sku</span>
                <span v-if="sortBy === 'Sku'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('Variant')">Variant <span v-if="sortBy === 'Variant'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('Price')">Price <span v-if="sortBy === 'Price'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <!-- <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('CreatedOnUtc')">CreatedOnUtc <span v-if="sortBy === 'CreatedOnUtc'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span></th> -->
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('UpdatedOnUtc')">Updated<span v-if="sortBy === 'UpdatedOnUtc'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('Published')">Published <span v-if="sortBy === 'Published'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span></th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="Product in products" :key="Product.Id"> 
                <td class="align-middle text-center text-sm">
                  <p class="text-xs text-center font-weight-bold mb-0">{{ Product.Id }}</p>
                  <!-- <img :src="Product.Images[0]" height="75"> -->
                  <div class="image-preview">
                    <img
                        :src="Product.Images[0]" height="75"
                        class="image-thumb"
                    >
                    <!-- <div class="image-popup"> -->
                    <div class="image-preview-modal">
                        <img
                            :src="Product.Images[0]"
                            class="image-large"
                        >
                    </div>
                  </div>
                  <!-- <img
                      :src="Product.Images[0]"
                      class="image-thumb" height="75"
                      @mouseenter="showPreview(Product.Images[0])"
                      @mouseleave="hidePreview"
                      @mousemove="movePreview"
                  />

                  <div
                      v-if="previewVisible"
                      class="floating-preview"
                      :style="previewStyle"
                  >

                      <img
                          :src="previewUrl"
                          class="floating-image"
                      />

                  </div> -->
                </td>
                <td class="align-middle text-center ">
                  <p class="text-sm text-center font-weight-bold mb-0">{{ Product.Name }}</p>
                  <p class="text-xs text-center text-secondary mb-0 brake-words"> {{ Product.ShortName?.substring(0, 75) }}{{ Product.ShortName?.length > 75 ? '...' : '' }}</p>
                  <!-- <p class="text-xs text-center text-secondary mb-0" style=""> {{ Product.ShortName }}</p> -->
                </td>
                <td class="align-middle text-center text-sm">
                  <p class="text-xs text-center font-weight-bold mb-0">{{ Product.CategoryName }}</p>
                  <p class="text-xs text-center text-secondary mb-0 break-word">{{ Product.CategoryId }}</p>
                </td>
                <td class="align-middle text-center text-sm">
                  <p class="text-xs font-weight-bold mb-0">{{ Product.Sku }}</p>
                </td>
                <td class="align-middle text-center">
                  <p class="text-xs font-weight-bold mb-0">{{ Product.Variant }}</p>
                </td>
                <td class="align-middle text-center">
                  <p class="text-xs font-weight-bold mb-0">{{ Product.Price }}</p>
                </td> 
                <!-- <td class="align-middle text-center">
                  <p class="text-xs font-weight-bold mb-0">{{ formatDateProduct.CreatedOnUtc) }}</p>
                </td> -->
                 <td class="align-middle text-center">
                  <p class="text-xs font-weight-bold mb-0">{{ formatDate(Product.UpdatedOnUtc) }}</p>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-success" v-if="Product.Published">Published</span>
                  <span class="badge badge-sm bg-gradient-warning" v-else>NOT Published</span>
                  <br/>
                  <span class="badge badge-sm bg-gradient-danger" v-if="Product.Deleted">Deleted</span>
                  <span class="badge badge-sm bg-gradient-secondary" v-else>NOT Deleted</span>
                </td>
                <!-- <td class="d-flex align-items-center justify-content-center h-100"> -->
                <td class="align-middle">
                  <a class="btn btn-link text-info px-3 mb-0" :href="Product.ProductUrl" target="_blank" v-if="!Product.Deleted"><i class="fas fa-eye me-2" aria-hidden="true"></i>View</a>
                  <br/>
                  <a class="btn btn-link text-secondary px-3 mb-0" :href="selectedShop.Url + '/Admin/Product/Edit/' + Product.Id" target="_blank" v-if="!Product.Deleted"><i class="fas fa-pencil-alt text-secondary me-2" aria-hidden="true"></i>Edit</a>
                  <!-- <a class="btn btn-link text-secondary px-3 mb-0" :href="'/productoffers?productId='+Product.Id" v-if="!Product.Deleted"><i class="fas fa-pencil-alt text-secondary me-2" aria-hidden="true"></i>Offers</a> -->
                </td>
                <td class="align-middle text-center">
                    <a
                      :href="'/productoffers?productId='+Product.Id"
                      class="text-secondary font-weight-bold text-xs"
                      data-toggle="tooltip"
                      data-original-title="Edit user"
                      v-if="!Product.Deleted">
                      <argon-button color="success" size="sm" variant="outline" v-if="Product.ProductOffersExists">Offers</argon-button>
                      <argon-button color="warning" size="sm" variant="outline" v-else>Add +</argon-button>
                    </a>
                    <br/>
                    <a
                      :href="'/inventory-stock?search='+Product.Sku"
                      class="text-secondary font-weight-bold text-xs"
                      data-toggle="tooltip"
                      data-original-title="Edit user"
                      >
                      <argon-button color="info" size="sm" variant="outline" >Stock</argon-button>
                    </a>
                    <br/>
                    <a
                      @click="
                            createInventory(
                                Product
                            )
                        "
                      class="text-secondary font-weight-bold text-xs"
                      data-toggle="tooltip"
                      data-original-title="Edit user"
                      >
                      <argon-button color="primary" size="sm" variant="outline" >Inventory</argon-button>
                    </a>
                    <!-- <ArgonButton
                        v-if="true"
                        color="success"
                        @click="
                            createInventory(
                                Product
                            )
                        "
                    >
                        Inventory
                    </ArgonButton>
                    <ArgonButton
                        v-else
                        color="info"
                        variant="outline"
                        @click="
                            openInventory(
                                Product
                            )
                        "
                    >
                        Przejdź do magazynu
                    </ArgonButton> -->
                </td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

